/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Login_HintInputs */

const cs_portal_login_hint = /** @type {(inputs: Portal_Login_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se e-mailem z pozvánky.`)
};

const en_portal_login_hint = /** @type {(inputs: Portal_Login_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with the e-mail from your invite.`)
};

/**
* | output |
* | --- |
* | "Sign in with the e-mail from your invite." |
*
* @param {Portal_Login_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_login_hint = /** @type {((inputs?: Portal_Login_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Login_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_login_hint(inputs)
	return cs_portal_login_hint(inputs)
});